import { render, staticRenderFns } from "./link-with-icon.vue?vue&type=template&id=59e2bbbb&scoped=true&"
import script from "./link-with-icon.vue?vue&type=script&lang=js&"
export * from "./link-with-icon.vue?vue&type=script&lang=js&"
import style0 from "./link-with-icon.vue?vue&type=style&index=0&id=59e2bbbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2bbbb",
  null
  
)

export default component.exports